import React, { useContext, useState } from "react";
import SearchIcon from "../../../assets/images/profile/search.svg";
import SortBtn from "../../../assets/images/tickets/sortBtn.svg";
import MoreIcon from "../../../assets/images/dashboard/more.svg";
import CalendarIcon from "../../../assets/images/dashboard/calendar.svg";
import { SharedDataContext } from "../../utils/UseContext";
import ExportButton from "../../utils/ExportButton";
import DatePicker from "../../../components/common/DatePicker";
import moment from "moment/moment";

const TicketSearchBar = ({
  t,
  toggleOpen,
  handleSearch,
  handleExport,
  iconExport,
  handleChangeDate
}) => {
  const { sharedDataContext, setSharedDataContext } = useContext(
    SharedDataContext
  );
  // const { asset_link } = sharedDataContext;
  return (
    <div className="searchBar">
      <div className={"filter-elements"}>
        <button className="buttonserch">
          <img className="view-more" src={SearchIcon} alt="SearchIcon" />
        </button>

        <input
          className="input input-search"
          type="text"
          placeholder={t("tickets.search_placeholder")}
          onChange={handleSearch}
          style={{ padding: "3px" }}
          maxLength={96}
        />

        <button className="button buttonFilter" onClick={toggleOpen}>
          <img className="view-more" src={SortBtn} alt="Sort Button" />

          {t("tickets.search_filter")}

          <img className="view-more" src={MoreIcon} alt="caneldar" />
        </button>
      </div>
      <div style={{ display: "flex" }}>
        <div
          className="button is-outlined"
          style={{
            width: "203px",
            borderRadius: "5px !important",
            height: "42px",
            marginRight: "15px"
          }}
        >
          <img className="calendar-icon" src={CalendarIcon} alt="caneldar" />

          <DatePicker
            startDate={moment().startOf("month")}
            endDate={moment().endOf("month")}
            t={t}
            getTimeFilter={(start, end) => handleChangeDate(start, end)}
          />
        </div>
        <ExportButton
          t={t}
          handleExport={handleExport}
          iconExport={iconExport}
        />
      </div>
    </div>
  );
};

export default TicketSearchBar;
